import styled from 'styled-components';
import { Form } from 'formik';

// Material components
import { Grid, Paper } from '@material-ui/core';

import { colors, din, easeTransition } from '../../styles/variables';
import { breakpoints } from '../../styles/breakpoints';
import { px, fade } from '../../util/style';
import without from '../../util/without';

import { ReactComponent as AlleviMarkRed } from '../svgs/AlleviMarkRed.svg';
import { PushButton } from './Buttons';

interface FormPageContainerProps {
  noPadTop?: boolean;
  onPrem?: boolean;
  noHeader?: boolean;
}

export const FormPageContainer = styled(without('noPadTop')(Grid))<FormPageContainerProps>`
  min-width: 400px;
  min-height: 100vh;
  margin: 0 auto;
  padding: ${px(48)} ${px(36)} ${px(72)} ${px(36)};
  background-color: ${colors.milk2};

  ${breakpoints.down('sm')} {
    padding: ${px(36)} ${px(24)};
  }

  ${breakpoints.up('md')} {
    padding: ${px(72)} ${px(72)};
  }

  ${breakpoints.up('lg')} {
    padding: ${px(72)} ${px(144)};
  }

  ${props =>
    props.noPadTop &&
    `
    padding-top: 0 !important;
  `}

  ${props =>
    props.onPrem &&
    `
    height: calc(100vh - ${px(210)});
  `}

  ${props =>
    props.noHeader &&
    `
    height: 100vh;
  `}

  ${props =>
    props.onPrem &&
    props.noHeader &&
    `
    height: calc(100vh - ${px(60)});
  `}
`;

export const FormPageBox = styled(Paper)`
  font-family: ${din};
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  flex-shrink: 0;
  border: 1px solid ${colors.gray13};
  border-radius: ${px(8)};
  padding: ${px(72)} ${px(72)} ${px(48)} ${px(72)};
`;

export const FormPageButton = styled(PushButton)`
  margin-left: auto !important;
  margin-right: auto !important;
`;

export const LogoContainer = styled.div`
  position: absolute;
  top: -1px;
  left: calc(50% - ${px(112)});
  height: 1px;
  background-color: #fff;
  padding: 0 ${px(16)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AlleviLogo = styled(AlleviMarkRed)`
  width: ${px(180)};
  fill: ${colors.alleviRed};
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

interface FormTextProps {
  success?: boolean;
}

export const FormText = styled.p<FormTextProps>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  max-width: ${px(500)};
  font-family: ${din};
  font-size: ${px(14)};
  color: ${colors.gray45};
  margin: 0;
  margin-bottom: ${px(36)};

  ${props =>
    props.success &&
    `
    margin-bottom: ${px(16)};
  `}

  & svg {
    height: ${px(24)};
    margin-right: ${px(8)};
  }

  & a {
    color: ${colors.rainLight};
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;

    &:hover {
      color: ${fade(colors.rainLight, 0.15)};
    }
  }
`;

export const FormPageLinkContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: ${px(24)};
`;

interface FormPageLinkProps {
  margintop?: boolean;
  large?: boolean;
}

export const FormPageLink = styled.a<FormPageLinkProps>`
  font-family: ${din};
  font-size: ${px(12)};
  color: ${colors.gray45};
  text-align: center;
  text-decoration: none;
  transition: color ${easeTransition};

  &:hover {
    color: ${colors.gray87};
  }

  ${props =>
    props.margintop &&
    `
    margin-top: ${px(24)};
  `}

  ${props =>
    props.large &&
    `
    font-size: ${px(14)};
    font-weight: 500;
    color: ${colors.rain};
    margin: 0;

    &:hover {
      color: ${colors.rainLight};
    }
  `}

  ${breakpoints.down('sm')} {
    font-size: ${px(14)};
  }
`;

export const LinkDivider = styled.div`
  width: ${px(4)};
  height: ${px(4)};
  border-radius: 100%;
  background-color: ${colors.gray45};
  margin: 0 ${px(8)};
`;
